import React, {forwardRef} from 'react';
import {NoteButtonView} from './Note.styles';
import type {ButtonProps} from '../Button/Button';

export type NoteButtonProps = ButtonProps;

/**
 * # NoteButton
 *
 * A button component for use within a Note.
 *
 * ## Usage
 *
 * ```jsx
 * import {Note, NoteBody, NoteButton} from '@packages/systems/spring';
 *
 * const Example = () => {
 *   return (
 *     <Note>
 *       <NoteBody>This is a note with a button.</NoteBody>
 *       <NoteButton>Click me</NoteButton>
 *     </Note>
 *   );
 * };
 * ```
 */
export const NoteButton = forwardRef<HTMLButtonElement, NoteButtonProps>(
  ({children, variant = 'outline', ...props}: NoteButtonProps, ref) => {
    return (
      <NoteButtonView variant={variant} {...props} ref={ref}>
        {children}
      </NoteButtonView>
    );
  }
);

NoteButton.displayName = 'NoteButton';
NoteButton.toString = NoteButtonView.toString;

export default NoteButton;
